<div class="wrapper">
	<div class="face-mask" [class.no-halo]="!halo">
		<img class="face" srcset="{{face}} 1x, {{face2x}} 2x" alt="face" />
	</div>
	<img *ngIf="logo" class="logo" srcset="{{logo}} 1x, {{logo2x}} 2x" alt="logo" />
</div>
